// top, left "=> left"%", bot%"tom

export const HOME_POSITION: any = {
    1: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "61.0%" },
        3: { left: "23.0%", bottom: "39.0%" },
        4: { left: "26.0%", bottom: "84.0%" },
        5: { left: "26.0%", bottom: "16.0%" },
        6: { left: "51.5%", bottom: "61.0%" },
        7: { left: "51.5%", bottom: "39.0%" },
        8: { left: "54.5%", bottom: "84.0%" },
        9: { left: "54.5%", bottom: "16.0%" },
        10: { left: "80.0%", bottom: "63.0%" },
        11: { left: "80.0%", bottom: "37.0%" },
    },
    2: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "61.0%" },
        3: { left: "23.0%", bottom: "39.0%" },
        4: { left: "26.0%", bottom: "84.0%" },
        5: { left: "26.0%", bottom: "16.0%" },
        6: { left: "48.5%", bottom: "50.0%" },
        7: { left: "51.5%", bottom: "77.5%" },
        8: { left: "51.5%", bottom: "22.5%" },
        9: { left: "80.0%", bottom: "77.5%" },
        10: { left: "77.0%", bottom: "50.0%" },
        11: { left: "80.0%", bottom: "22.5%" },
    },
    3: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "50.0%" },
        3: { left: "26.0%", bottom: "77.5%" },
        4: { left: "26.0%", bottom: "22.5%" },
        5: { left: "51.5%", bottom: "61.0%" },
        6: { left: "51.5%", bottom: "39.0%" },
        7: { left: "54.5%", bottom: "84.0%" },
        8: { left: "54.5%", bottom: "16.0%" },
        9: { left: "80.0%", bottom: "77.5%" },
        10: { left: "77.0%", bottom: "50.0%" },
        11: { left: "80.0%", bottom: "22.5%" },
    },
    4: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "50.0%" },
        3: { left: "26.0%", bottom: "77.5%" },
        4: { left: "26.0%", bottom: "22.5%" },
        5: { left: "50.5%", bottom: "70.0%" },
        6: { left: "50.5%", bottom: "30.0%" },
        7: { left: "53.5%", bottom: "50.0%" },
        8: { left: "53.5%", bottom: "90.0%" },
        9: { left: "53.5%", bottom: "10.0%" },
        10: { left: "80.0%", bottom: "63.0%" },
        11: { left: "80.0%", bottom: "37.0%" },
    },
    5: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "62.0%" },
        3: { left: "23.0%", bottom: "38.0%" },
        4: { left: "26.0%", bottom: "88.0%" },
        5: { left: "26.0%", bottom: "12.0%" },
        6: { left: "42.0%", bottom: "69.0%" },
        7: { left: "42.0%", bottom: "31.0%" },
        8: { left: "58.0%", bottom: "50.0%" },
        9: { left: "61.0%", bottom: "82.0%" },
        10: { left: "61.0%", bottom: "18.0%" },
        11: { left: "80.0%", bottom: "50.0%" },
    },
    6: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "26.0%", bottom: "50.0%" },
        3: { left: "23.0%", bottom: "30.0%" },
        4: { left: "23.0%", bottom: "70.0%" },
        5: { left: "26.0%", bottom: "10.0%" },
        6: { left: "26.0%", bottom: "90.0%" },
        7: { left: "51.5%", bottom: "61.0%" },
        8: { left: "51.5%", bottom: "39.0%" },
        9: { left: "54.5%", bottom: "84.0%" },
        10: { left: "54.5%", bottom: "16.0%" },
        11: { left: "80.0%", bottom: "50.0%" },
    },
    7: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "26.0%", bottom: "50.0%" },
        3: { left: "23.0%", bottom: "30.0%" },
        4: { left: "23.0%", bottom: "70.0%" },
        5: { left: "26.0%", bottom: "10.0%" },
        6: { left: "26.0%", bottom: "90.0%" },
        7: { left: "51.5%", bottom: "50.0%" },
        8: { left: "54.5%", bottom: "77.5%" },
        9: { left: "54.5%", bottom: "22.5%" },
        10: { left: "80.0%", bottom: "63.0%" },
        11: { left: "80.0%", bottom: "37.0%" },
    },
    8: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "62.0%" },
        3: { left: "23.0%", bottom: "38.0%" },
        4: { left: "26.0%", bottom: "88.0%" },
        5: { left: "26.0%", bottom: "12.0%" },
        6: { left: "42.0%", bottom: "50.0%" },
        7: { left: "45.0%", bottom: "82.0%" },
        8: { left: "45.0%", bottom: "18.0%" },
        9: { left: "61.0%", bottom: "50.0%" },
        10: { left: "80.0%", bottom: "63.0%" },
        11: { left: "80.0%", bottom: "37.0%" },
    },
    9: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "61.0%" },
        3: { left: "23.0%", bottom: "39.0%" },
        4: { left: "26.0%", bottom: "84.0%" },
        5: { left: "26.0%", bottom: "16.0%" },
        6: { left: "52.5%", bottom: "50.0%" },
        7: { left: "50.5%", bottom: "30.0%" },
        8: { left: "50.5%", bottom: "70.0%" },
        9: { left: "52.5%", bottom: "10.0%" },
        10: { left: "52.5%", bottom: "90.0%" },
        11: { left: "80.0%", bottom: "50.0%" },
    },
    10: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "61.0%" },
        3: { left: "23.0%", bottom: "39.0%" },
        4: { left: "26.0%", bottom: "84.0%" },
        5: { left: "26.0%", bottom: "16.0%" },
        6: { left: "50.5%", bottom: "63.0%" },
        7: { left: "50.5%", bottom: "37.0%" },
        8: { left: "77.0%", bottom: "61.0%" },
        9: { left: "77.0%", bottom: "39.0%" },
        10: { left: "80.0%", bottom: "84.0%" },
        11: { left: "80.0%", bottom: "16.0%" },
    },
    11: {
        1: { left: "5%", bottom: "50%" },
        2: { left: "23.0%", bottom: "50.0%" },
        3: { left: "26.0%", bottom: "82.0%" },
        4: { left: "26.0%", bottom: "18.0%" },
        5: { left: "42.0%", bottom: "62.0%" },
        6: { left: "42.0%", bottom: "38.0%" },
        7: { left: "45.0%", bottom: "12.0%" },
        8: { left: "45.0%", bottom: "88.0%" },
        9: { left: "61.0%", bottom: "31.0%" },
        10: { left: "61.0%", bottom: "69.0%" },
        11: { left: "80.0%", bottom: "50.0%" },
    },
    12: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "50.0%" },
        3: { left: "26.0%", bottom: "77.5%" },
        4: { left: "26.0%", bottom: "22.5%" },
        5: { left: "50.5%", bottom: "50.0%" },
        6: { left: "53.5%", bottom: "77.5%" },
        7: { left: "53.5%", bottom: "22.5%" },
        8: { left: "77.0%", bottom: "61.0%" },
        9: { left: "77.0%", bottom: "39.0%" },
        10: { left: "80.0%", bottom: "84.0%" },
        11: { left: "80.0%", bottom: "16.0%" },
    },
    17: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "26.0%", bottom: "50.0%" },
        3: { left: "23.0%", bottom: "30.0%" },
        4: { left: "23.0%", bottom: "70.0%" },
        5: { left: "26.0%", bottom: "10.0%" },
        6: { left: "26.0%", bottom: "90.0%" },
        7: { left: "51.5%", bottom: "50.0%" },
        8: { left: "54.5%", bottom: "77.5%" },
        9: { left: "54.5%", bottom: "22.5%" },
        10: { left: "80.0%", bottom: "63.0%" },
        11: { left: "80.0%", bottom: "37.0%" },
    },
    18: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "26.0%", bottom: "50.0%" },
        3: { left: "23.0%", bottom: "30.0%" },
        4: { left: "23.0%", bottom: "70.0%" },
        5: { left: "26.0%", bottom: "10.0%" },
        6: { left: "26.0%", bottom: "90.0%" },
        7: { left: "51.5%", bottom: "63.0%" },
        8: { left: "51.5%", bottom: "37.0%" },
        9: { left: "77.0%", bottom: "50.0%" },
        10: { left: "80.0%", bottom: "77.5%" },
        11: { left: "80.0%", bottom: "22.5%" },
    },
    19: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "61.0%" },
        3: { left: "23.0%", bottom: "39.0%" },
        4: { left: "26.0%", bottom: "84.0%" },
        5: { left: "26.0%", bottom: "16.0%" },
        6: { left: "53.5%", bottom: "50.0%" },
        7: { left: "50.5%", bottom: "30.0%" },
        8: { left: "50.5%", bottom: "70.0%" },
        9: { left: "53.5%", bottom: "10.0%" },
        10: { left: "53.5%", bottom: "90.0%" },
        11: { left: "80.0%", bottom: "50.0%" },
    },
    20: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "50.0%" },
        3: { left: "20.0%", bottom: "82.0%" },
        4: { left: "20.0%", bottom: "18.0%" },
        5: { left: "42.0%", bottom: "50.0%" },
        6: { left: "45.0%", bottom: "70.0%" },
        7: { left: "45.0%", bottom: "30.0%" },
        8: { left: "42.0%", bottom: "90.0%" },
        9: { left: "42.0%", bottom: "10.0%" },
        10: { left: "61.0%", bottom: "50.0%" },
        11: { left: "80.0%", bottom: "50.0%" },
    },
    21: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "26.0%", bottom: "50.0%" },
        3: { left: "23.0%", bottom: "30.0%" },
        4: { left: "23.0%", bottom: "70.0%" },
        5: { left: "26.0%", bottom: "10.0%" },
        6: { left: "26.0%", bottom: "90.0%" },
        7: { left: "51.5%", bottom: "61.0%" },
        8: { left: "51.5%", bottom: "39.0%" },
        9: { left: "54.5%", bottom: "84.0%" },
        10: { left: "54.5%", bottom: "16.0%" },
        11: { left: "80.0%", bottom: "50.0%" },
    },
    22: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "26.0%", bottom: "50.0%" },
        3: { left: "23.0%", bottom: "30.0%" },
        4: { left: "23.0%", bottom: "70.0%" },
        5: { left: "26.0%", bottom: "10.0%" },
        6: { left: "26.0%", bottom: "90.0%" },
        7: { left: "51.5%", bottom: "50.0%" },
        8: { left: "54.5%", bottom: "77.5%" },
        9: { left: "54.5%", bottom: "22.5%" },
        10: { left: "80.0%", bottom: "63.0%" },
        11: { left: "80.0%", bottom: "37.0%" },
    },
    23: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "38.0%" },
        3: { left: "23.0%", bottom: "62.0%" },
        4: { left: "26.0%", bottom: "88.0%" },
        5: { left: "26.0%", bottom: "12.0%" },
        6: { left: "42.0%", bottom: "50.0%" },
        7: { left: "45.0%", bottom: "82.0%" },
        8: { left: "45.0%", bottom: "18.0%" },
        9: { left: "61.0%", bottom: "50.0%" },
        10: { left: "80.0%", bottom: "63.0%" },
        11: { left: "80.0%", bottom: "37.0%" },
    },
    24: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "61.0%" },
        3: { left: "23.0%", bottom: "39.0%" },
        4: { left: "26.0%", bottom: "84.0%" },
        5: { left: "26.0%", bottom: "16.0%" },
        6: { left: "53.5%", bottom: "50.0%" },
        7: { left: "50.5%", bottom: "30.0%" },
        8: { left: "50.5%", bottom: "70.0%" },
        9: { left: "53.5%", bottom: "10.0%" },
        10: { left: "53.5%", bottom: "90.0%" },
        11: { left: "80.0%", bottom: "50.0%" },
    },
    25: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "61.0%" },
        3: { left: "23.0%", bottom: "39.0%" },
        4: { left: "26.0%", bottom: "84.0%" },
        5: { left: "26.0%", bottom: "16.0%" },
        6: { left: "50.5%", bottom: "64.5%" },
        7: { left: "50.5%", bottom: "35.5%" },
        8: { left: "77.0%", bottom: "61.0%" },
        9: { left: "77.0%", bottom: "39.0%" },
        10: { left: "80.0%", bottom: "84.0%" },
        11: { left: "80.0%", bottom: "16.0%" },
    },
    26: {
        1: { left: "5%", bottom: "50%" },
        2: { left: "23.0%", bottom: "50.0%" },
        3: { left: "26.0%", bottom: "82.0%" },
        4: { left: "26.0%", bottom: "18.0%" },
        5: { left: "42.0%", bottom: "62.0%" },
        6: { left: "42.0%", bottom: "38.0%" },
        7: { left: "45.0%", bottom: "12.0%" },
        8: { left: "45.0%", bottom: "88.0%" },
        9: { left: "61.0%", bottom: "31.0%" },
        10: { left: "61.0%", bottom: "69.0%" },
        11: { left: "80.0%", bottom: "50.0%" },
    },
    27: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "50.0%" },
        3: { left: "26.0%", bottom: "77.5%" },
        4: { left: "26.0%", bottom: "22.5%" },
        5: { left: "50.5%", bottom: "50.0%" },
        6: { left: "53.5%", bottom: "77.5%" },
        7: { left: "53.5%", bottom: "22.5%" },
        8: { left: "77.0%", bottom: "61.0%" },
        9: { left: "77.0%", bottom: "39.0%" },
        10: { left: "80.0%", bottom: "84.0%" },
        11: { left: "80.0%", bottom: "16.0%" },
    },
    32: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "26.0%", bottom: "50.0%" },
        3: { left: "23.0%", bottom: "30.0%" },
        4: { left: "23.0%", bottom: "70.0%" },
        5: { left: "26.0%", bottom: "10.0%" },
        6: { left: "26.0%", bottom: "90.0%" },
        7: { left: "51.5%", bottom: "50.0%" },
        8: { left: "54.5%", bottom: "77.5%" },
        9: { left: "54.5%", bottom: "22.5%" },
        10: { left: "80.0%", bottom: "63.0%" },
        11: { left: "80.0%", bottom: "37.0%" },
    },
    33: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "26.0%", bottom: "50.0%" },
        3: { left: "23.0%", bottom: "30.0%" },
        4: { left: "23.0%", bottom: "70.0%" },
        5: { left: "26.0%", bottom: "10.0%" },
        6: { left: "26.0%", bottom: "90.0%" },
        7: { left: "51.5%", bottom: "63.0%" },
        8: { left: "51.5%", bottom: "37.0%" },
        9: { left: "77.0%", bottom: "50.0%" },
        10: { left: "80.0%", bottom: "77.5%" },
        11: { left: "80.0%", bottom: "22.5%" },
    },
    34: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "61.0%" },
        3: { left: "23.0%", bottom: "39.0%" },
        4: { left: "26.0%", bottom: "84.0%" },
        5: { left: "26.0%", bottom: "16.0%" },
        6: { left: "53.5%", bottom: "50.0%" },
        7: { left: "50.5%", bottom: "30.0%" },
        8: { left: "50.5%", bottom: "70.0%" },
        9: { left: "53.5%", bottom: "10.0%" },
        10: { left: "53.5%", bottom: "90.0%" },
        11: { left: "80.0%", bottom: "50.0%" },
    },
    35: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "50.0%" },
        3: { left: "20.0%", bottom: "82.0%" },
        4: { left: "20.0%", bottom: "18.0%" },
        5: { left: "42.0%", bottom: "50.0%" },
        6: { left: "39.0%", bottom: "70.0%" },
        7: { left: "39.0%", bottom: "30.0%" },
        8: { left: "42.0%", bottom: "90.0%" },
        9: { left: "42.0%", bottom: "10.0%" },
        10: { left: "61.0%", bottom: "50.0%" },
        11: { left: "80.0%", bottom: "50.0%" },
    },
    36: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "50.0%" },
        3: { left: "20.0%", bottom: "82.0%" },
        4: { left: "20.0%", bottom: "18.0%" },
        5: { left: "42.0%", bottom: "50.0%" },
        6: { left: "39.0%", bottom: "82.0%" },
        7: { left: "39.0%", bottom: "18.0%" },
        8: { left: "61.0%", bottom: "50.0%" },
        9: { left: "80.0%", bottom: "50.0%" },
        10: { left: "77.0%", bottom: "82.0%" },
        11: { left: "77.0%", bottom: "18.0%" },
    },
    37: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "50.0%" },
        3: { left: "26.0%", bottom: "77.5%" },
        4: { left: "26.0%", bottom: "22.5%" },
        5: { left: "50.5%", bottom: "50.0%" },
        6: { left: "53.5%", bottom: "70.0%" },
        7: { left: "53.5%", bottom: "30.0%" },
        8: { left: "50.5%", bottom: "90.0%" },
        9: { left: "50.5%", bottom: "10.0%" },
        10: { left: "80.0%", bottom: "63.0%" },
        11: { left: "80.0%", bottom: "37.0%" },
    },
    38: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "50.0%" },
        3: { left: "20.0%", bottom: "82.0%" },
        4: { left: "20.0%", bottom: "18.0%" },
        5: { left: "42.0%", bottom: "50.0%" },
        6: { left: "39.0%", bottom: "82.0%" },
        7: { left: "39.0%", bottom: "18.0%" },
        8: { left: "61.0%", bottom: "63.0%" },
        9: { left: "61.0%", bottom: "37.0%" },
        10: { left: "80.0%", bottom: "63.0%" },
        11: { left: "80.0%", bottom: "37.0%" },
    },
    39: {
        1: { left: "5%", bottom: "50.0%" },
        2: { left: "23.0%", bottom: "62.0%" },
        3: { left: "23.0%", bottom: "38.0%" },
        4: { left: "26.0%", bottom: "88.0%" },
        5: { left: "26.0%", bottom: "12.0%" },
        6: { left: "53.0%", bottom: "50.0%" },
        7: { left: "46.0%", bottom: "77.5%" },
        8: { left: "46.0%", bottom: "22.5%" },
        9: { left: "80.0%", bottom: "50.0%" },
        10: { left: "70.0%", bottom: "77.5%" },
        11: { left: "70.0%", bottom: "22.5%" },
    },
};



// bottom, right "-> "right%", %"top

export const AWAY_POSITION: any = {
    1: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "61.0%" },
        3: { right: "27.0%", bottom: "39.0%" },
        4: { right: "30.0%", bottom: "84.0%" },
        5: { right: "30.0%", bottom: "16.0%" },
        6: { right: "55.5%", bottom: "61.0%" },
        7: { right: "55.5%", bottom: "39.0%" },
        8: { right: "58.5%", bottom: "84.0%" },
        9: { right: "58.5%", bottom: "16.0%" },
        10: { right: "84.0%", bottom: "63.0%" },
        11: { right: "84.0%", bottom: "37.0%" },
    },
    2: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "61.0%" },
        3: { right: "27.0%", bottom: "39.0%" },
        4: { right: "30.0%", bottom: "84.0%" },
        5: { right: "30.0%", bottom: "16.0%" },
        6: { right: "52.5%", bottom: "50.0%" },
        7: { right: "55.5%", bottom: "77.5%" },
        8: { right: "55.5%", bottom: "22.5%" },
        9: { right: "84.0%", bottom: "77.5%" },
        10: { right: "81.0%", bottom: "50.0%" },
        11: { right: "84.0%", bottom: "22.5%" },
    },
    3: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "50.0%" },
        3: { right: "30.0%", bottom: "77.5%" },
        4: { right: "30.0%", bottom: "22.5%" },
        5: { right: "55.5%", bottom: "61.0%" },
        6: { right: "55.5%", bottom: "39.0%" },
        7: { right: "58.5%", bottom: "84.0%" },
        8: { right: "58.5%", bottom: "16.0%" },
        9: { right: "84.0%", bottom: "77.5%" },
        10: { right: "81.0%", bottom: "50.0%" },
        11: { right: "84.0%", bottom: "22.5%" },
    },
    4: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "50.0%" },
        3: { right: "30.0%", bottom: "77.5%" },
        4: { right: "30.0%", bottom: "22.5%" },
        5: { right: "54.5%", bottom: "70.0%" },
        6: { right: "54.5%", bottom: "30.0%" },
        7: { right: "57.5%", bottom: "50.0%" },
        8: { right: "57.5%", bottom: "90.0%" },
        9: { right: "57.5%", bottom: "10.0%" },
        10: { right: "84.0%", bottom: "63.0%" },
        11: { right: "84.0%", bottom: "37.0%" },
    },
    5: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "62.0%" },
        3: { right: "27.0%", bottom: "38.0%" },
        4: { right: "30.0%", bottom: "88.0%" },
        5: { right: "30.0%", bottom: "12.0%" },
        6: { right: "46.0%", bottom: "69.0%" },
        7: { right: "46.0%", bottom: "31.0%" },
        8: { right: "62.0%", bottom: "50.0%" },
        9: { right: "65.0%", bottom: "82.0%" },
        10: { right: "65.0%", bottom: "18.0%" },
        11: { right: "84.0%", bottom: "50.0%" },
    },
    6: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "30.0%", bottom: "50.0%" },
        3: { right: "27.0%", bottom: "70.0%" },
        4: { right: "27.0%", bottom: "30.0%" },
        5: { right: "30.0%", bottom: "90.0%" },
        6: { right: "55.5%", bottom: "61.0%" },
        7: { right: "55.5%", bottom: "39.0%" },
        8: { right: "58.5%", bottom: "84.0%" },
        9: { right: "58.5%", bottom: "16.0%" },
        10: { right: "30.0%", bottom: "10.0%" },
        11: { right: "84.0%", bottom: "50.0%" },
    },
    7: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "30.0%", bottom: "50.0%" },
        3: { right: "27.0%", bottom: "70.0%" },
        4: { right: "27.0%", bottom: "30.0%" },
        5: { right: "30.0%", bottom: "90.0%" },
        6: { right: "30.0%", bottom: "10.0%" },
        7: { right: "55.5%", bottom: "50.0%" },
        8: { right: "58.5%", bottom: "22.5%" },
        9: { right: "58.5%", bottom: "77.5%" },
        10: { right: "84.0%", bottom: "63.0%" },
        11: { right: "84.0%", bottom: "37.0%" },
    },
    8: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "38.0%" },
        3: { right: "27.0%", bottom: "62.0%" },
        4: { right: "30.0%", bottom: "12.0%" },
        5: { right: "30.0%", bottom: "88.0%" },
        6: { right: "46.0%", bottom: "50.0%" },
        7: { right: "49.0%", bottom: "18.0%" },
        8: { right: "49.0%", bottom: "82.0%" },
        9: { right: "65.0%", bottom: "50.0%" },
        10: { right: "84.0%", bottom: "63.0%" },
        11: { right: "84.0%", bottom: "37.0%" },
    },
    9: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "39.0%" },
        3: { right: "27.0%", bottom: "61.0%" },
        4: { right: "30.0%", bottom: "16.0%" },
        5: { right: "30.0%", bottom: "84.0%" },
        6: { right: "57.5%", bottom: "50.0%" },
        7: { right: "54.5%", bottom: "70.0%" },
        8: { right: "54.5%", bottom: "30.0%" },
        9: { right: "57.5%", bottom: "90.0%" },
        10: { right: "57.5%", bottom: "10.0%" },
        11: { right: "84.0%", bottom: "50.0%" },
    },
    10: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "39.0%" },
        3: { right: "27.0%", bottom: "61.0%" },
        4: { right: "30.0%", bottom: "16.0%" },
        5: { right: "30.0%", bottom: "84.0%" },
        6: { right: "54.5%", bottom: "37.0%" },
        7: { right: "54.5%", bottom: "63.0%" },
        8: { right: "81.0%", bottom: "39.0%" },
        9: { right: "81.0%", bottom: "61.0%" },
        10: { right: "84.0%", bottom: "16.0%" },
        11: { right: "84.0%", bottom: "84.0%" },
    },
    11: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "50.0%" },
        3: { right: "30.0%", bottom: "82.0%" },
        4: { right: "30.0%", bottom: "18.0%" },
        5: { right: "46.0%", bottom: "62.0%" },
        6: { right: "46.0%", bottom: "38.0%" },
        7: { right: "49.0%", bottom: "12.0%" },
        8: { right: "49.0%", bottom: "88.0%" },
        9: { right: "65.0%", bottom: "31.0%" },
        10: { right: "65.0%", bottom: "69.0%" },
        11: { right: "84.0%", bottom: "50.0%" },
    },
    12: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "50.0%" },
        3: { right: "30.0%", bottom: "22.5%" },
        4: { right: "30.0%", bottom: "77.5%" },
        5: { right: "54.5%", bottom: "50.0%" },
        6: { right: "57.5%", bottom: "22.5%" },
        7: { right: "57.5%", bottom: "77.5%" },
        8: { right: "81.0%", bottom: "39.0%" },
        9: { right: "81.0%", bottom: "61.0%" },
        10: { right: "84.0%", bottom: "16.0%" },
        11: { right: "84.0%", bottom: "84.0%" },
    },
    17: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "30.0%", bottom: "50.0%" },
        3: { right: "27.0%", bottom: "30.0%" },
        4: { right: "27.0%", bottom: "70.0%" },
        5: { right: "30.0%", bottom: "10.0%" },
        6: { right: "30.0%", bottom: "90.0%" },
        7: { right: "55.5%", bottom: "50.0%" },
        8: { right: "58.5%", bottom: "77.5%" },
        9: { right: "58.5%", bottom: "22.5%" },
        10: { right: "84.0%", bottom: "63.0%" },
        11: { right: "84.0%", bottom: "37.0%" },
    },
    18: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "30.0%", bottom: "50.0%" },
        3: { right: "27.0%", bottom: "30.0%" },
        4: { right: "27.0%", bottom: "70.0%" },
        5: { right: "30.0%", bottom: "10.0%" },
        6: { right: "30.0%", bottom: "90.0%" },
        7: { right: "55.5%", bottom: "63.0%" },
        8: { right: "55.5%", bottom: "37.0%" },
        9: { right: "81.0%", bottom: "50.0%" },
        10: { right: "84.0%", bottom: "22.5%" },
        11: { right: "84.0%", bottom: "77.5%" },
    },
    19: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "39.0%" },
        3: { right: "27.0%", bottom: "61.0%" },
        4: { right: "30.0%", bottom: "16.0%" },
        5: { right: "30.0%", bottom: "84.0%" },
        6: { right: "57.5%", bottom: "50.0%" },
        7: { right: "57.5%", bottom: "10.0%" },
        8: { right: "57.5%", bottom: "90.0%" },
        9: { right: "54.5%", bottom: "30.0%" },
        10: { right: "54.5%", bottom: "70.0%" },
        11: { right: "84.0%", bottom: "50.0%" },
    },
    20: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "50.0%" },
        3: { right: "24.0%", bottom: "18.0%" },
        4: { right: "24.0%", bottom: "82.0%" },
        5: { right: "46.0%", bottom: "50.0%" },
        6: { right: "49.0%", bottom: "30.0%" },
        7: { right: "49.0%", bottom: "70.0%" },
        8: { right: "46.0%", bottom: "10.0%" },
        9: { right: "46.0%", bottom: "90.0%" },
        10: { right: "65.0%", bottom: "50.0%" },
        11: { right: "84.0%", bottom: "50.0%" },
    },
    21: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "30.0%", bottom: "50.0%" },
        3: { right: "27.0%", bottom: "30.0%" },
        4: { right: "27.0%", bottom: "70.0%" },
        5: { right: "30.0%", bottom: "10.0%" },
        6: { right: "30.0%", bottom: "90.0%" },
        7: { right: "55.5%", bottom: "61.0%" },
        8: { right: "55.5%", bottom: "39.0%" },
        9: { right: "58.5%", bottom: "84.0%" },
        10: { right: "58.5%", bottom: "16.0%" },
        11: { right: "84.0%", bottom: "50.0%" },
    },
    22: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "30.0%", bottom: "50.0%" },
        3: { right: "27.0%", bottom: "30.0%" },
        4: { right: "27.0%", bottom: "70.0%" },
        5: { right: "30.0%", bottom: "10.0%" },
        6: { right: "30.0%", bottom: "90.0%" },
        7: { right: "55.5%", bottom: "50.0%" },
        8: { right: "58.5%", bottom: "77.5%" },
        9: { right: "58.5%", bottom: "22.5%" },
        10: { right: "84.0%", bottom: "63.0%" },
        11: { right: "84.0%", bottom: "37.0%" },
    },
    23: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "62.0%" },
        3: { right: "27.0%", bottom: "38.0%" },
        4: { right: "30.0%", bottom: "88.0%" },
        5: { right: "30.0%", bottom: "12.0%" },
        6: { right: "46.0%", bottom: "50.0%" },
        7: { right: "49.0%", bottom: "82.0%" },
        8: { right: "49.0%", bottom: "18.0%" },
        9: { right: "65.0%", bottom: "50.0%" },
        10: { right: "84.0%", bottom: "63.0%" },
        11: { right: "84.0%", bottom: "37.0%" },
    },
    24: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "61.0%" },
        3: { right: "27.0%", bottom: "39.0%" },
        4: { right: "30.0%", bottom: "84.0%" },
        5: { right: "30.0%", bottom: "16.0%" },
        6: { right: "57.5%", bottom: "50.0%" },
        7: { right: "54.5%", bottom: "30.0%" },
        8: { right: "54.5%", bottom: "70.0%" },
        9: { right: "57.5%", bottom: "10.0%" },
        10: { right: "57.5%", bottom: "90.0%" },
        11: { right: "84.0%", bottom: "50.0%" },
    },
    25: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "61.0%" },
        3: { right: "27.0%", bottom: "39.0%" },
        4: { right: "30.0%", bottom: "84.0%" },
        5: { right: "30.0%", bottom: "16.0%" },
        6: { right: "54.5%", bottom: "63.0%" },
        7: { right: "54.5%", bottom: "37.0%" },
        8: { right: "81.0%", bottom: "61.0%" },
        9: { right: "81.0%", bottom: "39.0%" },
        10: { right: "84.0%", bottom: "84.0%" },
        11: { right: "84.0%", bottom: "16.0%" },
    },
    26: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "50.0%" },
        3: { right: "30.0%", bottom: "82.0%" },
        4: { right: "30.0%", bottom: "18.0%" },
        5: { right: "46.0%", bottom: "62.0%" },
        6: { right: "46.0%", bottom: "38.0%" },
        7: { right: "49.0%", bottom: "12.0%" },
        8: { right: "49.0%", bottom: "88.0%" },
        9: { right: "65.0%", bottom: "31.0%" },
        10: { right: "65.0%", bottom: "69.0%" },
        11: { right: "84.0%", bottom: "50.0%" },
    },
    27: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "50.0%" },
        3: { right: "30.0%", bottom: "77.5%" },
        4: { right: "30.0%", bottom: "22.5%" },
        5: { right: "54.5%", bottom: "50.0%" },
        6: { right: "57.5%", bottom: "77.5%" },
        7: { right: "57.5%", bottom: "22.5%" },
        8: { right: "81.0%", bottom: "61.0%" },
        9: { right: "81.0%", bottom: "39.0%" },
        10: { right: "84.0%", bottom: "84.0%" },
        11: { right: "84.0%", bottom: "16.0%" },
    },
    32: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "30.0%", bottom: "50.0%" },
        3: { right: "27.0%", bottom: "30.0%" },
        4: { right: "27.0%", bottom: "70.0%" },
        5: { right: "30.0%", bottom: "10.0%" },
        6: { right: "30.0%", bottom: "90.0%" },
        7: { right: "55.5%", bottom: "50.0%" },
        8: { right: "58.5%", bottom: "77.5%" },
        9: { right: "58.5%", bottom: "22.5%" },
        10: { right: "84.0%", bottom: "63.0%" },
        11: { right: "84.0%", bottom: "37.0%" },
    },
    33: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "30.0%", bottom: "50.0%" },
        3: { right: "27.0%", bottom: "30.0%" },
        4: { right: "27.0%", bottom: "70.0%" },
        5: { right: "30.0%", bottom: "10.0%" },
        6: { right: "30.0%", bottom: "90.0%" },
        7: { right: "55.5%", bottom: "63.0%" },
        8: { right: "55.5%", bottom: "37.0%" },
        9: { right: "81.0%", bottom: "50.0%" },
        10: { right: "84.0%", bottom: "77.5%" },
        11: { right: "84.0%", bottom: "22.5%" },
    },
    34: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "61.0%" },
        3: { right: "27.0%", bottom: "39.0%" },
        4: { right: "30.0%", bottom: "84.0%" },
        5: { right: "30.0%", bottom: "16.0%" },
        6: { right: "57.5%", bottom: "50.0%" },
        7: { right: "54.5%", bottom: "30.0%" },
        8: { right: "54.5%", bottom: "70.0%" },
        9: { right: "57.5%", bottom: "10.0%" },
        10: { right: "57.5%", bottom: "90.0%" },
        11: { right: "84.0%", bottom: "50.0%" },
    },
    35: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "50.0%" },
        3: { right: "24.0%", bottom: "82.0%" },
        4: { right: "24.0%", bottom: "18.0%" },
        5: { right: "46.0%", bottom: "50.0%" },
        6: { right: "43.0%", bottom: "70.0%" },
        7: { right: "43.0%", bottom: "30.0%" },
        8: { right: "46.0%", bottom: "90.0%" },
        9: { right: "46.0%", bottom: "10.0%" },
        10: { right: "65.0%", bottom: "50.0%" },
        11: { right: "84.0%", bottom: "50.0%" },
    },
    36: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "50.0%" },
        3: { right: "24.0%", bottom: "82.0%" },
        4: { right: "24.0%", bottom: "18.0%" },
        5: { right: "46.0%", bottom: "50.0%" },
        6: { right: "43.0%", bottom: "82.0%" },
        7: { right: "43.0%", bottom: "18.0%" },
        8: { right: "65.0%", bottom: "50.0%" },
        9: { right: "84.0%", bottom: "50.0%" },
        10: { right: "81.0%", bottom: "82.0%" },
        11: { right: "81.0%", bottom: "18.0%" },
    },
    37: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "50.0%" },
        3: { right: "30.0%", bottom: "77.5%" },
        4: { right: "30.0%", bottom: "22.5%" },
        5: { right: "54.5%", bottom: "50.0%" },
        6: { right: "57.5%", bottom: "70.0%" },
        7: { right: "57.5%", bottom: "30.0%" },
        8: { right: "54.5%", bottom: "90.0%" },
        9: { right: "54.5%", bottom: "10.0%" },
        10: { right: "84.0%", bottom: "63.0%" },
        11: { right: "84.0%", bottom: "37.0%" },
    },
    38: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "50.0%" },
        3: { right: "24.0%", bottom: "82.0%" },
        4: { right: "24.0%", bottom: "18.0%" },
        5: { right: "46.0%", bottom: "50.0%" },
        6: { right: "43.0%", bottom: "82.0%" },
        7: { right: "43.0%", bottom: "18.0%" },
        8: { right: "65.0%", bottom: "63.0%" },
        9: { right: "65.0%", bottom: "37.0%" },
        10: { right: "84.0%", bottom: "63.0%" },
        11: { right: "84.0%", bottom: "37.0%" },
    },
    39: {
        1: { right: "5%", bottom: "50%" },
        2: { right: "27.0%", bottom: "62.0%" },
        3: { right: "27.0%", bottom: "38.0%" },
        4: { right: "30.0%", bottom: "88.0%" },
        5: { right: "30.0%", bottom: "12.0%" },
        6: { right: "57.0%", bottom: "50.0%" },
        7: { right: "50.0%", bottom: "77.5%" },
        8: { right: "50.0%", bottom: "22.5%" },
        9: { right: "84.0%", bottom: "50.0%" },
        10: { right: "74.0%", bottom: "77.5%" },
        11: { right: "74.0%", bottom: "22.5%" },
    },
};
